import { ClientInferRequest, ClientInferResponseBody } from "@ts-rest/core";

import { api, contract } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";

export type CreateCustomSurfaceTreatmentPayload = ClientInferRequest<
  typeof contract.companySettings.createCustomSurfaceTreatment
>["body"];

export type CreateCustomSurfaceTreatmentResponse = ClientInferResponseBody<
  typeof contract.companySettings.createCustomSurfaceTreatment,
  201
>;

export const createCustomSurfaceTreatmentApi = async ({
  companyId,
  payload,
}: {
  companyId: string;
  payload: CreateCustomSurfaceTreatmentPayload;
}): Promise<CreateCustomSurfaceTreatmentResponse> => {
  const response = await api.companySettings.createCustomSurfaceTreatment.mutation({
    params: { id: companyId },
    body: payload,
  });

  if (response.status === 201) {
    return response.body;
  }

  throw new ApiError("Failed to create custom surface treatment", response.status, response.body);
};
